export function formatInteger(value: number): string {
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(value);
}

export function formatPercent(value: number): string {
  const normalized = value > 1 ? value / 100 : value;
  return new Intl.NumberFormat(undefined, { style: "percent", maximumFractionDigits: 0 }).format(
    normalized,
  );
}

export function formatBytes(value: number): string {
  if (value < 1024) return `${value} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let size = value / 1024;
  let index = 0;
  while (size >= 1024 && index < units.length - 1) {
    size /= 1024;
    index += 1;
  }
  return `${size >= 10 ? size.toFixed(0) : size.toFixed(1)} ${units[index]}`;
}

export function formatDateTime(value: string | Date | null): string {
  if (value === null) return "Not available";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.valueOf())) return "Invalid timestamp";
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

export function relativeTime(value: string | Date | null, now = new Date()): string {
  if (value === null) return "Never";
  const date = value instanceof Date ? value : new Date(value);
  const deltaSeconds = Math.round((date.valueOf() - now.valueOf()) / 1000);
  if (!Number.isFinite(deltaSeconds)) return "Unknown";
  const formatter = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  const intervals = [
    [60, "second"],
    [60, "minute"],
    [24, "hour"],
    [7, "day"],
    [4.345, "week"],
    [12, "month"],
    [Number.POSITIVE_INFINITY, "year"],
  ] as const;
  let amount = deltaSeconds;
  for (const [divisor, unit] of intervals) {
    if (Math.abs(amount) < divisor) return formatter.format(Math.round(amount), unit);
    amount /= divisor;
  }
  return formatter.format(Math.round(amount), "year");
}

export function shortHash(value: string, visible = 10): string {
  if (value.length <= visible * 2 + 1) return value;
  return `${value.slice(0, visible)}…${value.slice(-visible)}`;
}

export function titleCase(value: string): string {
  return value.replaceAll("_", " ").replace(/\b\w/g, (character) => character.toUpperCase());
}
